export {default} from "./PricingCard";
